import {DeliveryGroup} from "../../../types/schedule/delivery-group";
import {DeliveryGroupDto} from "../../../types/schedule/delivery-group-dto";
import {DeliveryGroupStatus} from "../../../types/schedule/delivery-group-status";
import {DeliveryGroupType} from "../../../types/schedule/delivery-group-type";
import {ScheduleDto} from "../../../types/schedule/schedule-dto";
import {addressFormatByDeliveryGroup} from "../../address/address-format";
import {convertLocationDtoToLocation} from "../location/location-converter";
import {convertDeliveryInGroupDtoToDeliveryInGroup} from "./delivery-in-group-converter";

export const convertDeliveryGroupDtoToDeliveryGroup = (
    deliveryGroupDto: DeliveryGroupDto,
    scheduleDto: ScheduleDto,
    isCurrent: boolean,
    isWait: boolean,
): DeliveryGroup => {
    const isReported = !isCurrent && !isWait && !!deliveryGroupDto.reportedAt
    const isWork = isCurrent && scheduleDto.completedAt === null

    return {
        location: convertLocationDtoToLocation(deliveryGroupDto.location),
        type: deliveryGroupDto.type,
        estimatedTimeOfArrival: deliveryGroupDto.estimatedTimeOfArrival,
        startTimeLimited: deliveryGroupDto.startTimeLimited,
        endTimeLimited: deliveryGroupDto.endTimeLimited,
        startedAt: deliveryGroupDto.startedAt,
        reportedAt: deliveryGroupDto.reportedAt,
        deliveriesInGroup: deliveryGroupDto.deliveriesInGroup.map(
            (deliveryInGroupDto) =>
                convertDeliveryInGroupDtoToDeliveryInGroup(
                    deliveryInGroupDto,
                    scheduleDto
                )
        ),
        startedCount: deliveryGroupDto.startedCount,
        completedCount: deliveryGroupDto.completedCount,
        totalCount: deliveryGroupDto.totalCount,
        issueCount: deliveryGroupDto.issueCount,
        inspectCount: deliveryGroupDto.inspectCount,
        retryCount: deliveryGroupDto.retryCount || 0,

        formattedAddress: addressFormatByDeliveryGroup(deliveryGroupDto),

        isPickUp: deliveryGroupDto.type === DeliveryGroupType.PickUp,
        isDropOff: deliveryGroupDto.type === DeliveryGroupType.DropOff,

        displayType:
            deliveryGroupDto.type === DeliveryGroupType.PickUp ? "상차" : "전달",

        isDelay:
            !!deliveryGroupDto.reportedAt &&
            deliveryGroupDto.reportedAt > deliveryGroupDto.endTimeLimited,
        isExpectedDelay:
            isWork &&
            !!deliveryGroupDto.estimatedTimeOfArrival &&
            deliveryGroupDto.estimatedTimeOfArrival > deliveryGroupDto.endTimeLimited,

        isWait: isWait,
        isWork: isWork,
        isReported: isReported,
        deliveryIds: getDeliveryIds(deliveryGroupDto),
    };
};

const getDeliveryStatus = (deliveryGroupDto: DeliveryGroupDto) => {
    if (deliveryGroupDto.reportedAt) {
        return DeliveryGroupStatus.Reported;
    }
    if (deliveryGroupDto.startedAt) {
        return DeliveryGroupStatus.Work;
    }
    return DeliveryGroupStatus.Wait;
};

const getDeliveryIds = (deliveryGroupDto: DeliveryGroupDto) => {
    return deliveryGroupDto.deliveriesInGroup.map((deliveryInGroupDto) => {
        return deliveryInGroupDto.id;
    });
};
